<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row class="mb-1">
          <b-col cols="12">
            <b-row>
              <b-form-group
                label="Nome"
                class="col-12 mb-50"
              >
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Nome"
                >
                  <b-form-input
                    v-model="form.nome"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-row>
            <b-row>
              <b-col
                cols="6"
                style="display: flex;"
              >
                <b-form-checkbox
                  v-model="form.gerente"
                  style="margin-left: 2px;"
                  size="sm"
                  value="true"
                  unchecked-value="false"
                  class="detail-check-sm"
                >
                  Gerente
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="form.coordenador"
                  style="margin-left: 10px;"
                  size="sm"
                  value="true"
                  unchecked-value="false"
                  class="detail-check-sm"
                >
                  Coordenador
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-form-group
            label="Descrição (opcional)"
            class="col-12"
          >
            <b-textarea v-model="form.descricao" />
          </b-form-group>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<style>

.detail-check-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label::before,
.detail-check-sm.input-group-sm .custom-checkbox .custom-control-label::before {
  left: 0px !important;
}

.detail-check-sm.custom-checkbox.b-custom-control-sm .custom-control-label {
  font-size: 0.95rem !important;
}
</style>

<script>

import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import api from '@/app-modulo/comuns/funcao/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'Funcao',
  components: {
    CadastroBase,
    ValidationProvider,
  },
  data() {
    return {
      required,
      form: {
        nome: null,
        descricao: null,
        gerente: false,
        coordenador: false,
      },
      immutableForm: {},
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getFuncao(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (this.state === 'novo') {
          api.createFuncao(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Função cadastrada com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateFuncao(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Função alterada com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
  },
}
</script>
